module.exports = __webpack_public_path__ + "img/9788996268840.9ef437a1.jpg";